import React from 'react'

import StripePaymentMethod from './StripePaymentMethod';

export default class StripePaymentMethodsList extends React.Component {

    renderNoMethods() {
        return <div className="item default">{I18n.t("cart_summary.credit_cards.no_credit_cards_present")}</div>
    }

    renderMethods() {
        return <div>
            { this.props.methods.map((method, index)=> {
                return <StripePaymentMethod key={index}
                                            isSelected={method.id === this.props.selectedMethod}
                                            method={method}
                                            onSelect={this.props.onPaymentMethodSelected}
                                            onDelete={this.props.onPaymentMethodDeleted}
                                            canBeDeleted={true || this.props.methods.length > 1}
                />
            })
            }
        </div>
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <label>{I18n.t("cart_summary.credit_cards.choose_a_card")}</label>
                    </div>
                </div>
                <div className="stripe-payment-methods">
                    { (this.props.methods.length > 0) ? this.renderMethods() : this.renderNoMethods() }
                </div>
            </div>
        );
    }
}